import * as types from './types';
import { uiActions } from 'state/modules/UI';
import * as actions from 'services/api/promoCodes';
import { getErrorMessage, parsePagination, isCancel } from 'utils';
import i18n from 'i18n-js';

// GET PROMO CODES
const fetchPromoCodesRequest = () => ({
  type: types.FETCH_PROMO_CODES_REQUEST,
});

const fetchPromoCodesSuccess = (payload) => ({
  type: types.FETCH_PROMO_CODES_SUCCESS,
  payload,
});

const fetchPromoCodesFailed = (errors) => ({
  type: types.FETCH_PROMO_CODES_FAILED,
  errors,
});

export const fetchPromoCodes = (params, options) => {
  return async (dispatch) => {
    dispatch(fetchPromoCodesRequest());

    const response = await actions.fetchPromoCodes(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchPromoCodesSuccess({
          data: response.data,
          pagination,
        })
      );
    }

    if (!isCancel(response)) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: getErrorMessage(response.data),
        })
      );
      dispatch(fetchPromoCodesFailed(response.data));
    }
  };
};

// GET PROMO CODE BY ID
const fetchPromoCodesByIdRequest = () => ({
  type: types.FETCH_PROMO_CODE_BY_ID_REQUEST,
});

const fetchPromoCodeByIdSuccess = (payload) => ({
  type: types.FETCH_PROMO_CODE_BY_ID_SUCCESS,
  payload,
});

const fetchPromoCodeByIdFailed = (errors) => ({
  type: types.FETCH_PROMO_CODE_BY_ID_FAILED,
  errors,
});

export const fetchPromoCodeById = (id) => {
  return async (dispatch) => {
    dispatch(fetchPromoCodesByIdRequest());

    const response = await actions.fetchPromoCodeById(id);

    if (response.ok) {
      return dispatch(
        fetchPromoCodeByIdSuccess({
          data: response.data,
        })
      );
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchPromoCodeByIdFailed(response.data));
  };
};

// Create Promo Code
const createPromoCodeRequest = () => ({
  type: types.CREATE_PROMO_CODE_REQUEST,
});

const createPromoCodeSuccess = (payload) => ({
  type: types.CREATE_PROMO_CODE_SUCCESS,
  payload,
});

const createPromoCodeFailed = () => ({
  type: types.CREATE_PROMO_CODE_FAILED,
});

export const createPromoCode = (payload) => {
  return async (dispatch) => {
    dispatch(createPromoCodeRequest());

    const response = await actions.createPromoCode(payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('promo_codes.create_success'),
        })
      );
      return dispatch(createPromoCodeSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(createPromoCodeFailed());
  };
};

export const resetPromoCode = () => ({
  type: types.RESET_PROMO_CODE,
});

const deletePromoCodeRequest = () => ({
  type: types.DELETE_PROMO_CODE_REQUEST,
});

const deletePromoCodeSuccess = (payload) => ({
  type: types.DELETE_PROMO_CODE_SUCCESS,
  payload,
});

const deletePromoCodeFailed = (errors) => ({
  type: types.DELETE_PROMO_CODE_FAILED,
  errors,
});

// Delete promo code

export const deletePromoCode = (id) => {
  return async (dispatch) => {
    dispatch(deletePromoCodeRequest());

    const response = await actions.deletePromoCode(id);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('promo_codes.delete_success'),
        })
      );
      return dispatch(deletePromoCodeSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, {}, true);
    if (typeof formattedError === 'string') {
      dispatch(deletePromoCodeFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: i18n.t('promo_codes.delete_failure'),
      })
    );

    return dispatch(deletePromoCodeFailed(errors));
  };
};

// UPDATE PROMO CODE
const updatePromoCodeRequest = () => ({
  type: types.UPDATE_PROMO_CODE_REQUEST,
});

const updatePromoCodeSuccess = (payload) => ({
  type: types.UPDATE_PROMO_CODE_SUCCESS,
  payload,
});

const updatePromoCodeFailed = (errors) => ({
  type: types.UPDATE_PROMO_CODE_FAILED,
  errors,
});

export const updatePromoCodeReset = (payload) => ({
  type: types.UPDATE_PROMO_CODE_RESET,
  payload,
});

export const updatePromoCode = (id, payload) => {
  return async (dispatch) => {
    dispatch(updatePromoCodeRequest());

    const response = await actions.updatePromoCode(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('promo_codes.update_success'),
        })
      );
      return dispatch(updatePromoCodeSuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(updatePromoCodeFailed(response.data));
  };
};
